import Layout from 'components/layout';

import React from 'react';

import { Box, Heading, PostList, VerticalHero, NewsletterCta } from '@lucid/components';
import { useSmartlingStrings } from '@lucid/hooks';

import { useBlogNewsletter } from 'hooks/hooks';
import type { Lucid } from 'types/types';

interface BlogTaxonomyBaseProps {
  defaultProps: Lucid.Context.Blog.Context.PageProps;
}

const BlogTaxonomyBase = ({ defaultProps }: BlogTaxonomyBaseProps) => {
  const { pageContext, data } = defaultProps;

  const {
    directus: { posts },
  } = data;

  const {
    shouldHideSsr = false,
    shortCode,
    urlLangPrefix,
    localeId,
    pageType,
    nid,
    blogTermName = '',
    blogTermText = '',
    blogTaxonomySlug = '',
    page = 1,
    pageCount = 1,
    metatags,
    nodeTranslations,
    product,
  } = pageContext;

  const withSmartling = useSmartlingStrings({
    keys: ['mktg_blog_no_posts'],
    shortCode,
  });
  const { newsletterSignUpURL } = useBlogNewsletter(shortCode);

  return (
    <Layout
      shouldDisplayBlogNav
      localeId={localeId}
      metatags={metatags}
      nid={nid}
      nodeTranslations={nodeTranslations}
      pageType={pageType}
      product={product}
      shortCode={shortCode}
      shouldHideSsr={shouldHideSsr}
      urlLangPrefix={urlLangPrefix}
    >
      <Box
        css={theme => ({
          background: theme.colors.coolGrey[10],
          paddingBottom: theme.space.s16,
          paddingTop: theme.space.s80,
        })}
      >
        <VerticalHero header={blogTermName} headingLevel="h1" headingVariant="hero3XL700" subheader={blogTermText} />
      </Box>
      {posts && posts.length > 0 ? (
        <PostList
          currentPage={page}
          pathRoot={blogTaxonomySlug}
          posts={(posts || []) as unknown as Lucid.Directus.Generated.Blog_Post[]}
          totalPageCount={pageCount}
        />
      ) : (
        <Heading
          as="h2"
          css={theme => ({ textAlign: 'center', padding: `${theme.space.s120}px 0` })}
          data-testid="no-posts"
        >
          {withSmartling('mktg_blog_no_posts')}
        </Heading>
      )}
      <NewsletterCta
        css={theme => ({ backgroundColor: theme.colors.blue[10] })}
        newsletterSignUpUrl={newsletterSignUpURL}
      />
    </Layout>
  );
};

export default BlogTaxonomyBase;
